import { RunContextApp } from "framework/RCApp";
import { SESSION_ACTIONS_TYPES } from "store/actions/sessionActions";

export interface SessionReducerState {
  isLoggedIn : boolean
  token ?: string
  error ?: string
}

export interface SessionReducerAction {
  type     : string
  payload ?: any
}

let defaultState : SessionReducerState = {
  isLoggedIn : false
}
export const sessionReducer = (rc : RunContextApp) => (
  state = { ...defaultState } as SessionReducerState,

  action : SessionReducerAction) => {
    switch(action.type){
      case SESSION_ACTIONS_TYPES.SET_LOGGED_IN : 
        state = {
          ...state,
          isLoggedIn : true,
          token: action.payload
        }
        break;
      case SESSION_ACTIONS_TYPES.SSO_FAILED : 
        state = {
          ...state,
          error : action.payload
        }
        break;
      default :
        break;
    }
    return state;
}